import { GoogleAuthProvider, signInWithPopup } from "@firebase/auth";
// import { toast, ToastContainer } from "react-toastify";
import { postData } from "../api";
import { AddUserUrl, EmailLoginUrl, GoogleLoginUrl } from "../constants/endPoints";
import { auth } from "../constants/FirebaseConstraints";
// import useVechaiuiNotification from "../Hooks/useVechaiuiNotification";
import { Modal, notification } from "antd";
import useLocalStorage from "../Hooks/useLocalStorage";
import { useHistory } from "react-router";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { countryCodes } from "../constants/countryCodes";
import SEO from "../Components/SEO";
import VerifyCodeModal from "./Components/VerifyCodeModal";
import CaptchaField from "./Components/CaptchaField";
import { savePendingVerification, clearPendingVerification } from "../constants/pendingVerification";
// import 'firebaseu'
// const auth = getAuth();
// const provider = new GoogleAuthProvider();
// provider.setCustomParameters({ prompt: 'select_account' });
// const [user,setUser] = u
const Signup = () => {
    const googleAuthProvider = new GoogleAuthProvider();
    const [user, setUser] = useLocalStorage("user");
    const history = useHistory();
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [username, setUserName] = useState("");
    const [signupPhone, setSignupPhone] = useState("");
    const [signupCountryCode, setSignupCountryCode] = useState("+244");
    const [isLoading, setIsLoading] = useState(false);
    const [verifyState, setVerifyState] = useState({ visible: false, userId: null, email: "" });
    const captchaRef = useRef(null);
    const signInWithGoogle = () => {
        signInWithPopup(auth, googleAuthProvider).then(async (res) => {
            console.log(res)
            if (!res.user) {
                return;
            }
            try {
                let data = {
                    google_id: res.user.uid,
                    user_name: res.user.displayName,
                    user_email: res.user.email,
                    profile_photo_url: res.user.photoURL,
                };
                console.log(data);
                let response = await postData(GoogleLoginUrl, data);
                if (response.data.user_id) {
                    setUser(response.data);
                    notification.success({
                        message: "Success",
                        description: "Successfully Logged In"
                    });
                    history.push('/');
                }
                // notificationHandler("Success","Logged In Successfully",'success');
                // messageHandler("Logged In Successfully",'success');
                console.log(response);
            } catch (e) {
                console.log(e);
            }
        }).catch(e => {
            console.log(e)
        });
    }

    const signupUser = async () => {
        try {
            if (email.length < 1) {
                notification.error({
                    message: "Error",
                    description: "Please enter valid email address"
                });
                return;
            }
            if (password.length < 1) {
                notification.error({
                    message: "Error",
                    description: "Please enter valid password"
                });
                return;
            }
            if (username.length < 1) {
                notification.error({
                    message: "Error",
                    description: "Please enter valid username"
                });
                return;
            }
            if (signupPhone.replace(/\D/g, '').length < 6) {
                notification.error({
                    message: "Error",
                    description: "Please enter a valid phone number"
                });
                return;
            }
            if (!captchaRef.current || !captchaRef.current.code) {
                notification.error({
                    message: "Error",
                    description: "Introduza o código de segurança da imagem."
                });
                return;
            }

            const data = {
                user_email: email,
                user_password: password,
                user_name: username,
                user_phone: signupCountryCode + signupPhone.replace(/\D/g, ''),
                device_token: "Web",
                captcha_id: captchaRef.current.captchaId,
                captcha_code: captchaRef.current.code,
            }
            setIsLoading(true);
            let response = await postData(AddUserUrl, data, true);
            setIsLoading(false);
            if (!response.data) {
                // The backend already consumed this captcha attempt (right or
                // wrong) — a retry always needs a fresh image.
                if (captchaRef.current) captchaRef.current.refresh();
                return
            }
            if (response.data.user_id) {
                // status 2 = the admin has email verification turned on and
                // this account is still waiting on the code just emailed to it.
                if (Number(response.data.status) === 2) {
                    savePendingVerification(response.data.user_id, response.data.user_email);
                    setVerifyState({ visible: true, userId: response.data.user_id, email: response.data.user_email });
                    notification.info({
                        message: "Verifique o seu email",
                        description: "Enviámos um código de verificação para o seu email. Insira-o para ativar a sua conta."
                    });
                    return;
                }
                setUser(response.data);
                notification.success({
                    message: "Success",
                    description: "Successfully Signed up"
                });
                history.push('login');
            } else {
            }
        } catch (e) {
            console.log("login error: ", e);
        }

    }

    const onVerified = (userData) => {
        clearPendingVerification();
        setVerifyState({ visible: false, userId: null, email: "" });
        setUser(userData);
        notification.success({
            message: "Conta verificada",
            description: "A sua conta foi ativada. Pode agora entrar."
        });
        history.push('login');
    }

    return (
        <div className="login-page">
            <SEO title="Criar Conta | InfoMotores" description="Crie a sua conta gratuita na InfoMotores e comece a comprar, vender ou alugar carros, motas, barcos e máquinas em Angola." noindex />
            <VerifyCodeModal
                visible={verifyState.visible}
                userId={verifyState.userId}
                email={verifyState.email}
                onVerified={onVerified}
                onCancel={() => setVerifyState({ ...verifyState, visible: false })}
            />
            <div className="login-page-container">
                <main>
                    <nav className="auth-nav">
                        <div className="auth-nav-start">
                            <Link to="/" className="auth-nav-brand">
                                <img src="/external_assets/img/app_logo.png" alt="Infomotores" />
                            </Link>
                            <Link to="/" className="auth-nav-link ms-sm-5">Pagina inicial</Link>
                        </div>
                        <Link to="/login" className="btn btn-outline-danger auth-nav-cta">Entrar</Link>
                    </nav>
                    <section className="h-100">
                        <div className="container py-5 h-100">
                            <div className="row d-flex align-items-stretch justify-content-center h-100">
                                <div className="col-12 col-md-6 col-lg-6 text-center mb-4 mb-md-0">
                                    <div className="auth-logo-wrap">
                                        <img src="/external_assets/img/auth_banner.png" className="auth-logo" alt="InfoMotores — anuncie a venda ou aluguer de carros, peças, barcos, máquinas e motas" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="auth-form">
                                    <div className="specials auth-heading">
                                        <h2>Criar Conta</h2>
                                        <p className="auth-subtitle">Preencha os seus dados para começar a comprar, vender ou alugar.</p>
                                    </div>
                                    <form>
                                        {/* User name */}
                                        <div className="form-outline mb-4">
                                            <input
                                                type="text"
                                                id="username"
                                                className="form-control form-control-lg"
                                                value={username}
                                                onChange={(e) => setUserName(e.target.value)}
                                            />
                                            <label
                                                className="form-label"
                                                htmlFor="username"


                                            >User Name</label>
                                        </div>
                                        {/* <!-- Email input --> */}
                                        <div className="form-outline mb-4">
                                            <input
                                                type="email"
                                                id="email"
                                                className="form-control form-control-lg"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <label
                                                className="form-label"
                                                htmlFor="email"


                                            >Email address</label>
                                        </div>

                                        {/* <!-- Phone input (country code + number in one row) --> */}
                                        <div className="form-outline mb-4">
                                            <div className="auth-phone-field">
                                                <select
                                                    id="signup-country"
                                                    className="form-control form-control-lg auth-phone-code"
                                                    value={signupCountryCode}
                                                    onChange={(e) => setSignupCountryCode(e.target.value)}
                                                    aria-label="País"
                                                >
                                                    {countryCodes.map((c) => (
                                                        <option value={c.dial} key={c.name}>{c.name} ({c.dial})</option>
                                                    ))}
                                                </select>
                                                <input
                                                    type="tel"
                                                    id="signup-phone"
                                                    className="form-control form-control-lg"
                                                    placeholder="9XX XXX XXX"
                                                    value={signupPhone}
                                                    onChange={(e) => setSignupPhone(e.target.value)}
                                                />
                                            </div>
                                            <label
                                                className="form-label"
                                                htmlFor="signup-phone"
                                            >Telefone</label>
                                        </div>

                                        {/* <!-- Password input --> */}
                                        <div className="form-outline mb-4">
                                            <input
                                                type="password"
                                                id="password"
                                                className="form-control form-control-lg"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <label className="form-label" htmlFor="password">Password</label>
                                        </div>

                                        <CaptchaField ref={captchaRef} />

                                        {/* <!-- Submit button --> */}
                                        <div className="d-grid">
                                            <button type="button" onClick={signupUser} className="btn btn-primary btn-lg" disabled={isLoading}>
                                               Create Account
                                            </button>
                                        </div>

                                    </form>
                                    <div className="pt-3 text-center">
                                        <Link to={'/login'}>
                                            Already Have Account? Login.
                                        </Link>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}

export default Signup;